import { MutationTree }      from 'vuex';
import { TooltipParams }     from '@/components/chart/chart.types';
import { ChartTooltipState } from '@/components/chart/chart-tooltip/chart-tooltip.types';

const mutations: MutationTree<ChartTooltipState> = {
  setNewParams(state, payload: TooltipParams[]): void {
    state.params = payload;
  },
  switchTooltipVisibility(state, visible: boolean): void {
    if (state.isTooltipVisible !== visible) {
      state.isTooltipVisible = visible;
    }
  },
};

export default mutations;
